import src from "IMAGE";
export default { src, width: 70, height: 124, blurWidth: 0, blurHeight: 0};
